module.exports = __webpack_public_path__ + "static/media/team-work.adec418f.jpg";